
import React, { Component } from "react";
import {Input} from "@chakra-ui/react";
import PtiParser from "../Parsers/PtiParser";


export default class TextParserMapInput extends Component 
{
    constructor(props)
    {
        super(props);

        this.onValueChange = this.onValueChange.bind(this);
    }



    onValueChange(e) 
    {
        var parsedObject = {};
        if (this.props.card.parserType === "pti")
        {
            // when we get more, then factory approach
            var parsedResult = PtiParser.parseV2(e.target.value, this.props.card.fieldMap.lotDetails?.lotDetailsMap);
            this.mapParsedFields(parsedResult);
        }
        this.props.onValueChange(e.target.value);
    }

    repressOverwrite(key, valueBag, overwriteRules)
    {
        if (!overwriteRules) return false;
        if (overwriteRules.overAllProps) return false;
        if (!overwriteRules.doNotOverwriteProps) return false;
        if (! Array.isArray(overwriteRules.doNotOverwriteProps)) return false;

        var hasDoNotOverwriteKey = overwriteRules.doNotOverwriteProps.includes(key);
        if (!hasDoNotOverwriteKey) return false;
        var doNotOverwriteKeyIsInValueBag = (key in valueBag);
      if (!doNotOverwriteKeyIsInValueBag) return false;
      if ((valueBag[key].trim() === "") || (valueBag[key] == null)) return false;
      return true;
    }
  
    mapParsedFields(parsedObject) {
      for (var key in parsedObject) {
        var val = parsedObject[key];
        if (val && val !== "") 
        {
          if (this.props.card.fieldMap[key]) {
            var mappedField = this.props.card.fieldMap[key];

            if (!this.repressOverwrite(mappedField, this.props.valueBag, this.props.card.overwriteRules))
            {
                // we are NOT changing the current card here - only the mapped card
                this.props.onValueChange(val, mappedField, false);
            }
          }
        }
      }
    }
  


    render() 
    {
        return(                

                <Input
                autoFocus
                    backgroundColor={"white"}
                    placeholder={this.props.card.attribTitle}
                    name={this.props.card.Id}
                    value={this.props.cardValue}
                    onChange={this.onValueChange}
                />

        )
    }
}







